import { API_ENDPOINTS, SM_QUEUE_SERVER, TYPE_CALL } from "../constants/constants";
import { messageApiReprogram, triggerNotifications, updateInfoCall } from "../Helpers/helperMessages";
import { callbacksToDialModel } from "../mappers/models.mapper";
import { Logger } from "../logging/Logger";
import { MESSAGE_CODE, MESSAGE_FROM, MESSAGE_TYPE } from "../constants/Notifications";
export const reprogramToServer=
(sdkResource, dispositionID, subdispositionID, dateCallBack, telephone, existingNumber, userID, requestTimeout, callKey, data1, data2, data3, data4, data5)=> {
    const { callType, campID, callOutID, selectedPhoneItem } = sdkResource.sharedCallOutData;
    const maxDaysToReprogramCall = sdkResource.sharedData.getGeneralPermissions()[35];
    const phone = existingNumber ? selectedPhoneItem.number : telephone;
    const telReprogram = callType === 1 ? 1 : !existingNumber ? 0 : selectedPhoneItem.id;
    const disposition = Math.max(parseInt(dispositionID), 0);
    const subDisposition = Math.max(parseInt(subdispositionID), 0);
    const today = new Date();
    let limitDay = new Date(today);
    limitDay.setDate(limitDay.getDate() + parseInt(maxDaysToReprogramCall));
    limitDay.setHours(23, 59, 59);

    const callbackDate = new Date(dateCallBack);
    if (callbackDate <= today) {
        triggerNotifications(sdkResource, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11203], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        return console.warn("[AgentSDK] [reprograming call] [Error]: The rescheduling date entered is before current date.");
    }
    if (callbackDate >= limitDay) {
        triggerNotifications(sdkResource, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11204], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
        return console.warn("[AgentSDK] [reprograming call] [Error]: The rescheduling date entered is greater than the established in [setting 35].");
    }

    const cleanDate = dateCallBack.replace(/-/g, "/").replace(/T/, " ").split(":", 2).join(":");

    const objResponse = sdkResource.apiCont.getObjectResponse();
    const message = {
        CallOutId: callOutID,
        Id: campID,
        Type: callType === 2 ? 1 : 0,
        UserId: userID,
        CamId: campID,
    };
    
    sdkResource.apiCont.dispositionList(message, objResponse, requestTimeout);
    objResponse.onError = (messageError) => {
        console.error("[AgentSDK] [ResponseFromServer] [Error]: Error in DB → " + messageError);
        Logger.Warn("[AgentSDK] [ResponseFromServer] [Error]: Error in DB → " + messageError);
    };

    objResponse.onCatch = (messageError) => {
        Logger.Warn("[AgentSDK] [ResponseFromServer] [Error]: Error → " + messageError);
    };

    objResponse.onSuccess = (objResponse) => {
        const objDispositions = [objResponse.Dispositions];
        const validateDispositions = Object.keys(objResponse.Dispositions).length === 0;

        const canReprogramDisposition = dispositionID > 0 && objDispositions.map((g) => g[dispositionID].CanReprogram)[0];
        const searchSubReprogram = subdispositionID > 0 && objDispositions.map((h) => h[dispositionID].SubDisposition[subdispositionID].CanReprogram); 
        const canReprogramSubdisposition = Array.isArray(searchSubReprogram) ? searchSubReprogram[0] : searchSubReprogram;
                
        if (validateDispositions) {
            triggerNotifications(sdkResource, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11205], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
            return console.warn("[AgentSDK] [reprograming call] [Error]: No dispositions assigned to campaign.");
        }

        if (!canReprogramDisposition && !canReprogramSubdisposition) {
            triggerNotifications(sdkResource, MESSAGE_CODE.REPROGRAM_CALL.OUTBOUND[11206], MESSAGE_TYPE.ERROR, MESSAGE_FROM.SDK);
            return console.warn("[AgentSDK] [reprograming call] [Error]: The disposition selected cannot reschedule the call, please use another disposition.");
        }

        if (callType === TYPE_CALL.INBOUND) {
            const callKy = /^[A-Za-z0-9]+$/.test(callKey) ? callKey : null;
            const dataInfo = [data1, data2, data3, data4, data5].map(data => userData(data) ? '' : data);
            const updateInfo = updateInfoCall(callKy, campID, dataInfo, callOutID);
            sdkResource.sendToRabbit(SM_QUEUE_SERVER, updateInfo);
        }

        const objCallBack = { CamId: campID, Phone: phone, TelReprograma: telReprogram, IsAuto: false, DateDial: cleanDate };
        const sendCallBack = messageApiReprogram(API_ENDPOINTS.CALL_BACK, objCallBack);
        sdkResource.sendToRabbit(SM_QUEUE_SERVER, sendCallBack);
        sdkResource.saveDisposition(disposition, subDisposition);
        getSvrCallbacks(sdkResource, userID, requestTimeout, 0);
    };
}

export const getSvrCallbacks = (sdkResource, userID, requestTimeout, campaignID) => {
    const objResponse = sdkResource.apiCont.getObjectResponse();
    const message = {
        CallOutId: sdkResource.sharedCallOutData.callOutID,            
        Id: sdkResource.sharedCallOutData.campID,
        Type: sdkResource.sharedCallOutData.callType === 2 ? 1 : 0,
        UserId: userID,
        CamId: campaignID === 0 ? sdkResource.sharedCallOutData.campID : campaignID,
    };
    sdkResource.apiCont.dispositionList(message, objResponse, requestTimeout);
    objResponse.onError = function (messageError) {
        console.error("[AgentSDK] [ResponseFromServer] [Error]: Error in DB → " + messageError);
        Logger.Warn("[AgentSDK] [ResponseFromServer] [Error]: Error in DB → " + messageError);
    };
    objResponse.onCatch = function (messageError){
        console.warn("[AgentSDK] [ResponseFromServer] [Error]: Error → " + messageError);
    };
    objResponse.onSuccess = function (objResponse) {
        const callbackModel = callbacksToDialModel(objResponse.CallBacksDays);
        sdkResource.svrEvents.onCallbacksToDial(callbackModel);
        sdkResource.svrEvents.onCallbacksPerCampaign(objResponse.CampaignCallBacks);
    };
}

function userData(param){
    return param === undefined || param === null || param === "" || param === "null" || param === "undefined";
}

